<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-personal-information`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M46 42.316v.646a1 1 0 01-1 1h-2.038c-.537 0-.971-.425-1.021-.96a5.261 5.261 0 00-.022-.198C41.403 38.952 38.494 36 35.323 36h-5.668c-3.192 0-6.1 2.991-6.585 6.881a4.663 4.663 0 00-.012.118c-.052.536-.484.963-1.022.963H20a1 1 0 01-1-1v-.646c0-4.715 3.25-8.691 7.486-9.922a8.485 8.485 0 1112.09.014C42.784 33.654 46 37.618 46 42.316zM6 8v30h8.75v4H4a2 2 0 01-2-2V6a2 2 0 012-2h36a2 2 0 012 2v11.489a16.653 16.653 0 00-4-2.449V8H6zm4 10a1 1 0 011-1h9a1 1 0 011 1v2a1 1 0 01-1 1h-9a1 1 0 01-1-1v-2zm0 8a1 1 0 011-1h4a1 1 0 011 1v2a1 1 0 01-1 1h-4a1 1 0 01-1-1v-2zm22.538-4.038a4.485 4.485 0 100 8.97 4.485 4.485 0 000-8.97z"/></svg>
</template>
<script>

export default {
  name: 'IconPersonalInformation',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
